import React from 'react'
import PropTypes from 'prop-types';
import Dialog from 'components/Dialog';
import Tr from 'translations/Translations'
import {makeStyles} from "@material-ui/styles";
import {Table, TableBody, TableCell, TableHead, TableRow, Typography} from "@material-ui/core";
import DoubleButton from "components/popup/components/DoubleButton";

const useStyle = makeStyles(theme => ({
    headColumn: {
        borderBottomColor: "none",
        paddingBottom: 0,
        fontSize: "1.1rem",
        backgroundColor: theme.palette.background.greyBackground,
    },
    column: {
        backgroundColor: theme.palette.background.greyBackground,
        width: "50%",
        padding: theme.spacing(0.5, 2, 0.5, 2),
        fontSize: "0.9rem",
    }
}))

export const getVerificationBeforePlaceOfferPopupConfig = (list, positionIds) => ({list, positionIds})

function VerificationBeforePlaceOfferPopup(
    {
        onCancel,
        onConfirm,
        config
    }) {
    const classes = useStyle();

    return (
        <Dialog
            open
            title={Tr('verification_before_place_popup_title')}
            maxWidth='lg'
            dialogActions={<DoubleButton
                justify='flex-end'
                labelFirst={Tr("cancel")}
                labelSecond={Tr("confirm2")}
                onClickFirst={onCancel}
                onClickSecond={()=> onConfirm(config.positionIds)}
            />}
        >
            <Table>
                {config.list.map((elem, i) => <React.Fragment key={i}><TableHead>
                    <TableRow>
                        <TableCell colSpan={2} className={classes.headColumn}>
                            {elem.positionName}
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell className={classes.column}>
                            {Tr("source_file_name")}
                        </TableCell>
                        <TableCell className={classes.column}>
                            {Tr("signed_file_name")}
                        </TableCell>
                    </TableRow>
                </TableHead>
                    <TableBody>
                        {
                            elem.files.map((file, j) => <TableRow key={j}>
                                <TableCell>
                                    <Typography color={!file.signedFile ? "error" : undefined}>
                                        {!file.signedFile ? Tr('source_file_name_error') : file.signedFile.name}
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <Typography color={file.signatureFiles.length === 0 ? "error" : undefined}>
                                    {file.signatureFiles.length === 0 ? Tr('signed_file_name_error') :
                                        file.signatureFiles.map(sFile => <React.Fragment key={sFile.identity}>{sFile.name}<br/></React.Fragment>)}
                                    </Typography>
                                </TableCell>
                            </TableRow>)
                        }
                    </TableBody>
                </React.Fragment>)}
            </Table>
        </Dialog>
    )
}

VerificationBeforePlaceOfferPopup.propTypes = {
    onCancel: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    config: PropTypes.shape({
        list: PropTypes.array.isRequired,
        positionIds: PropTypes.any
    })
}

export default VerificationBeforePlaceOfferPopup;
